/* GB collection v3 (2026-10-18, Emi: "smoother, faster, simpler").
   1. Type pills (All / Pistols / ...) swap the grid in place: no page reload, instant highlight, back button works.
   2. "Show more" adds the next blasters under the ones already shown (nothing disappears).
   3. Add-ons page: "Tap your blaster" photo tiles filter the add-ons instantly in the browser (v4: photo badges, ?blaster=).
   4. Shellblaster page bottom: add-on finder (v4).
   Uses Shopify's Section Rendering API. Falls back to normal links if anything fails. */
(function () {
  'use strict';
  if (window.__gbv3Collection) return;
  window.__gbv3Collection = true;

  var doc = document;
  var responses = new Map();

  function grid() { return doc.getElementById('product-grid'); }
  function gridSectionId() { var g = grid(); return g ? g.getAttribute('data-id') : ''; }
  function pills() { return doc.querySelector('.gbcf'); }
  function pillsSectionId() {
    var p = pills();
    var s = p ? p.closest('.shopify-section') : null;
    return s && s.id ? s.id.replace(/^shopify-section-/, '') : '';
  }
  function cleanParams(url) {
    var u = new URL(url, location.href);
    ['sections', 'section_id', 'page'].forEach(function (k) { u.searchParams.delete(k); });
    return u.searchParams.toString();
  }
  function pageUrl(params) {
    return location.pathname + (params ? '?' + params : '');
  }
  function syncDawn(params) {
    if (window.FacetFiltersForm) window.FacetFiltersForm.searchParamsPrev = params;
  }

  function fetchSections(params) {
    var ids = [pillsSectionId(), gridSectionId()].filter(Boolean);
    var url = pageUrl(params) + (params ? '&' : '?') + 'sections=' + ids.join(',');
    if (!responses.has(url)) {
      responses.set(url, fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).catch(function (error) {
        responses.delete(url);
        throw error;
      }));
    }
    return responses.get(url);
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function apply(json) {
    var pid = pillsSectionId();
    var gid = gridSectionId();
    if (pid && json[pid]) {
      var newPills = parse(json[pid]).querySelector('.gbcf');
      var oldPills = pills();
      if (newPills && oldPills) {
        var row = oldPills.querySelector('.gbcf-row');
        var scroll = row ? row.scrollLeft : 0;
        oldPills.replaceWith(doc.importNode(newPills, true));
        var newRow = pills() && pills().querySelector('.gbcf-row');
        if (newRow) newRow.scrollLeft = scroll;
      }
    }
    if (gid && json[gid]) {
      var fresh = parse(json[gid]).getElementById('ProductGridContainer');
      var container = doc.getElementById('ProductGridContainer');
      if (fresh && container) container.innerHTML = fresh.innerHTML;
    }
    if (window.GBKits) doc.querySelectorAll('[data-gbk]').forEach(window.GBKits.render);
    startFit();
    startPickers();
  }

  function setBusy(on) {
    var c = doc.getElementById('ProductGridContainer');
    if (c) c.classList.toggle('gbv3-busy', !!on);
  }

  function keepPillsInView() {
    var p = pills();
    if (!p) return;
    var top = p.getBoundingClientRect().top;
    if (top < 0) window.scrollTo({ top: window.scrollY + top - 110, behavior: 'smooth' });
  }

  function showType(href, push) {
    var params = cleanParams(href);
    setBusy(true);
    return fetchSections(params).then(function (json) {
      apply(json);
      if (push) history.pushState({ searchParams: params, gbv3: 1 }, '', pageUrl(params));
      syncDawn(params);
      keepPillsInView();
    }).catch(function () {
      window.location.assign(pageUrl(params));
    }).then(function () {
      setBusy(false);
    });
  }

  /* ---------- 1. type pills ---------- */
  doc.addEventListener('pointerdown', function (event) {
    var a = event.target.closest && event.target.closest('a.gbcf-pill[href]');
    if (a && grid()) fetchSections(cleanParams(a.href)).catch(function () {});
  }, { passive: true });

  doc.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var a = event.target.closest && event.target.closest('a.gbcf-pill[href]');
    if (!a || !grid() || !pillsSectionId()) return;
    var target = new URL(a.href, location.href);
    if (target.pathname !== location.pathname) return;
    event.preventDefault();
    var p = pills();
    if (p) p.querySelectorAll('.gbcf-pill').forEach(function (x) { x.classList.toggle('is-active', x === a); });
    showType(a.href, true);
  });

  /* Back / forward: we render pills + grid together. Dawn's facets.js also listens to popstate and would
     re-render only the grid (pills would lag behind), so its popstate-driven render (updateURLHash === false)
     is switched off here. facets.js runs before this file (same section, both deferred). */
  if (window.FacetFiltersForm && !window.FacetFiltersForm.__gbv3) {
    var dawnRender = window.FacetFiltersForm.renderPage;
    window.FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      if (updateURLHash === false && grid() && pillsSectionId()) {
        window.FacetFiltersForm.searchParamsPrev = searchParams;
        return;
      }
      return dawnRender.apply(this, arguments);
    };
    window.FacetFiltersForm.__gbv3 = true;
  }

  window.addEventListener('popstate', function (event) {
    if (!grid()) return;
    var params = event.state && typeof event.state.searchParams === 'string'
      ? event.state.searchParams
      : (window.FacetFiltersForm ? window.FacetFiltersForm.searchParamsInitial : cleanParams(location.href));
    syncDawn(params);
    showType(location.href, false);
  }, true);

  /* ---------- 2. show more ---------- */
  function appendPage(link) {
    var url = new URL(link.getAttribute('href'), location.href);
    url.searchParams.set('section_id', gridSectionId());
    return fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var page = parse(html);
      var target = grid();
      page.querySelectorAll('#product-grid > li.grid__item:not(.gbk-slot)').forEach(function (li) {
        target.appendChild(doc.importNode(li, true));
      });
      var fresh = page.querySelector('[data-gbv3-more]');
      var old = doc.querySelector('[data-gbv3-more]');
      if (old) {
        if (fresh) old.replaceWith(doc.importNode(fresh, true));
        else old.remove();
      }
      return num(link.getAttribute('data-page'));
    });
  }

  function num(v) { var n = parseInt(v, 10); return isFinite(n) ? n : 0; }

  function rememberPage(page) {
    var st = history.state || {};
    var next = {};
    Object.keys(st).forEach(function (k) { next[k] = st[k]; });
    next.searchParams = cleanParams(location.href);
    next.gbv3Page = page;
    history.replaceState(next, '');
  }

  doc.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-gbv3-next]');
    if (!link || !grid()) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Loading…';
    appendPage(link).then(rememberPage).catch(function () {
      window.location.assign(link.href);
    });
  });

  window.addEventListener('pagehide', function () {
    var st = history.state;
    if (st && st.gbv3Page > 1) {
      var next = {};
      Object.keys(st).forEach(function (k) { next[k] = st[k]; });
      next.gbv3Scroll = window.scrollY;
      history.replaceState(next, '');
    }
  });

  /* Coming back from a product page (no back-forward cache): load the same pages again, then the same spot. */
  function restore() {
    var st = history.state;
    var url = new URL(location.href);
    var landedPage = num(url.searchParams.get('page'));
    if (landedPage > 1 && grid()) {
      /* An old ?page=N link: show blasters 1..N in order instead of a random-looking middle page. */
      var params = cleanParams(location.href);
      history.replaceState({ searchParams: params, gbv3Page: landedPage }, '', pageUrl(params));
      var first = grid().querySelector('li.grid__item');
      var chain = Promise.resolve();
      for (var p = 1; p < landedPage; p += 1) {
        (function (pageNo) {
          chain = chain.then(function () {
            var u = new URL(pageUrl(params), location.href);
            u.searchParams.set('page', String(pageNo));
            u.searchParams.set('section_id', gridSectionId());
            return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
              parse(html).querySelectorAll('#product-grid > li.grid__item').forEach(function (li) {
                grid().insertBefore(doc.importNode(li, true), first);
              });
            });
          });
        })(p);
      }
      return;
    }
    if (!st || !(st.gbv3Page > 1) || !grid()) return;
    var more = doc.querySelector('[data-gbv3-next]');
    if (!more) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var wanted = st.gbv3Page;
    var scrollY = st.gbv3Scroll || 0;
    var step = function () {
      var link = doc.querySelector('[data-gbv3-next]');
      if (!link || num(link.getAttribute('data-page')) > wanted) return Promise.resolve();
      return appendPage(link).then(step);
    };
    step().then(function () {
      window.scrollTo(0, scrollY);
      if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
    }).catch(function () {});
  }

  /* ---------- 3. add-ons page: "Tap your blaster" (v4) ---------- */
  function sortItems(lis, attr) {
    return lis.sort(function (a, b) { return num(a.getAttribute(attr)) - num(b.getAttribute(attr)); });
  }

  function rowRTL(row) { return !!(window.getComputedStyle && window.getComputedStyle(row).direction === 'rtl'); }

  function centerTile(row, tile) {
    if (!row || !tile) return;
    var left = tile.offsetLeft - (row.clientWidth - tile.offsetWidth) / 2;
    row.scrollLeft = rowRTL(row) ? Math.min(0, left) : Math.max(0, left);
    if (row.__gbv4Browse) row.__gbv4Browse();
  }

  /* The top blaster-type pills use the same swipe controls without changing their links or server markup. */
  var typePickerId = 0;
  function addTypePickers() {
    doc.querySelectorAll('.gbcf .gbcf-row').forEach(function (row) {
      if (row.closest('[data-gbv4-picker]')) return;
      var picker = doc.createElement('div');
      picker.className = 'gbv4-picker gbv4-picker--types';
      picker.setAttribute('data-gbv4-picker', '');
      var track = doc.createElement('div');
      track.className = 'gbv4-track';
      row.parentNode.insertBefore(picker, row);
      picker.appendChild(track);
      track.appendChild(row);
      row.classList.add('gbv4-row');
      if (!row.id) row.id = 'GbV5Types-' + (++typePickerId);
      var footer = doc.createElement('div');
      footer.className = 'gbv4-browse';
      footer.setAttribute('data-gbv4-browse', '');
      footer.hidden = true;
      var label = doc.createElement('span');
      label.className = 'gbv4-browse__label';
      label.textContent = 'Swipe for more';
      footer.appendChild(label);
      var buttons = doc.createElement('div');
      buttons.className = 'gbv4-browse__buttons';
      ['prev', 'next'].forEach(function (direction) {
        var button = doc.createElement('button');
        button.type = 'button';
        button.className = 'gbv4-browse__button';
        button.setAttribute('data-gbv4-' + direction, '');
        button.setAttribute('aria-label', direction === 'prev' ? 'Previous blaster types' : 'More blaster types');
        button.setAttribute('aria-controls', row.id);
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true" focusable="false"><path d="' + (direction === 'prev' ? 'm14 5-7 7 7 7' : 'm10 5 7 7-7 7') + '"/></svg>';
        buttons.appendChild(button);
      });
      footer.appendChild(buttons);
      picker.appendChild(footer);
    });
  }

  /* v5: one set of controls per row, including newly rendered filter pills. No touch interception. */
  function startPickers() {
    addTypePickers();
    doc.querySelectorAll('[data-gbv4-picker]').forEach(function (picker) {
      var row = picker.querySelector('.gbv4-row');
      var footer = picker.querySelector('[data-gbv4-browse]');
      var prev = picker.querySelector('[data-gbv4-prev]');
      var next = picker.querySelector('[data-gbv4-next]');
      if (!row || !footer || !prev || !next) return;
      if (row.__gbv4Browse) { row.__gbv4Browse(); return; }
      var frame = false;
      function position() {
        var max = Math.max(0, row.scrollWidth - row.clientWidth);
        var left = rowRTL(row) ? -row.scrollLeft : row.scrollLeft;
        return { max: max, left: Math.max(0, Math.min(max, left)) };
      }
      function update() {
        frame = false;
        var p = position();
        footer.hidden = p.max <= 1;
        /* Native scroll snapping can retain the row's 2px start padding. */
        prev.disabled = p.left <= 4;
        next.disabled = p.left >= p.max - 4;
        picker.classList.toggle('has-more', !footer.hidden && !next.disabled);
        picker.classList.toggle('is-rtl', rowRTL(row));
      }
      function schedule() {
        if (frame) return;
        frame = true;
        window.requestAnimationFrame(update);
      }
      function advance(direction) {
        var p = position();
        var left = Math.max(0, Math.min(p.max, p.left + direction * row.clientWidth * .85));
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        row.scrollTo({ left: rowRTL(row) ? -left : left, behavior: reduced ? 'auto' : 'smooth' });
        schedule();
      }
      row.__gbv4Browse = schedule;
      row.addEventListener('scroll', schedule, { passive: true });
      prev.addEventListener('click', function () { advance(-1); });
      next.addEventListener('click', function () { advance(1); });
      update();
    });
  }
  window.addEventListener('resize', startPickers, { passive: true });

  /* The photo badge on each add-on picture: picked blaster -> its photo + ✓; All -> the photos it was rendered with. */
  function fitBadge(li, tile) {
    var badge = li.querySelector('[data-gbv4-fit]');
    if (!badge || badge.classList.contains('gbv4-fit--all')) return;
    if (badge.__gbv4Orig == null) badge.__gbv4Orig = badge.innerHTML;
    if (!tile) {
      badge.innerHTML = badge.__gbv4Orig;
      badge.classList.remove('is-mine');
      return;
    }
    var img = doc.createElement('img');
    img.src = tile.getAttribute('data-gbv4-img') || '';
    img.alt = '';
    img.width = 34;
    img.height = 34;
    var tick = doc.createElement('i');
    tick.setAttribute('aria-hidden', 'true');
    tick.textContent = '✓';
    badge.textContent = '';
    badge.appendChild(img);
    badge.appendChild(tick);
    badge.classList.add('is-mine');
  }

  function pickFit(box, btn, updateUrl) {
    var key = btn.getAttribute('data-gbv3-fit');
    var picked = key !== 'all';
    box.querySelectorAll('[data-gbv3-fit]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var shown = 0;
    var g = grid();
    if (g) {
      var lis = Array.prototype.slice.call(g.querySelectorAll(':scope > li.grid__item'));
      lis.forEach(function (li) {
        var ok = !picked || (li.getAttribute('data-gbv3-fits') || '').indexOf(',' + key + ',') !== -1;
        li.hidden = !ok;
        if (ok) shown += 1;
        fitBadge(li, picked ? btn : null);
      });
      /* Picked blaster: its ammo, clip and targets first. All: the page order. */
      sortItems(lis, picked ? 'data-gbv4-rank' : 'data-gbv4-i').forEach(function (li) { g.appendChild(li); });
    }
    var pre = doc.getElementById('gbv4-pre');
    if (pre) pre.remove();
    var count = box.querySelector('[data-gbv3-fit-count]');
    if (count) {
      count.hidden = !picked;
      count.textContent = picked ? '✓ ' + shown + (shown === 1 ? ' fits your ' : ' fit your ') + (btn.getAttribute('data-gbv3-fit-name') || '') : '';
    }
    if (updateUrl) {
      var u = new URL(location.href);
      if (picked) u.searchParams.set('blaster', key);
      else u.searchParams.delete('blaster');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    }
    if (picked) {
      try { sessionStorage.setItem('gbv4Blaster', key); } catch (error) {}
    }
  }

  doc.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-gbv3-fit]');
    if (!btn) return;
    var box = btn.closest('[data-gbv3-fit-pills]');
    if (box) pickFit(box, btn, true);
  });

  /* ?blaster=raven (a shared link, or back from a product page) opens the add-ons page filtered. */
  function startFit() {
    var box = doc.querySelector('[data-gbv3-fit-pills]');
    if (!box) return;
    var m = /[?&]blaster=([a-z0-9-]+)/.exec(location.search);
    var btn = m ? box.querySelector('[data-gbv3-fit="' + m[1] + '"]') : null;
    if (btn) {
      pickFit(box, btn, false);
      centerTile(box.querySelector('.gbv4-row'), btn);
    } else {
      var pre = doc.getElementById('gbv4-pre');
      if (pre) pre.remove();
    }
  }

  /* ---------- 4. Shellblaster page bottom: add-on finder (v4) ---------- */
  /* Tap your blaster -> every fitting add-on is visible right here, best fits first (v4.2:
     no extra tap or jump to the add-ons page). Cards come from the add-ons page grid, fetched once just before this block
     scrolls into view (the page itself renders as fast as before).
     Which blaster first: a tap in this visit, else a blaster already in the cart, else Raven. */
  function startFinder() {
    var box = doc.querySelector('[data-gbv4-finder]');
    var list = box && box.querySelector('[data-gbv4-cards]');
    if (!box || !list) return;
    var allLink = box.querySelector('[data-gbv4-all]');
    var items = null;
    var loading = null;
    var renderedKey = '';
    var alias = {};
    try { alias = JSON.parse((box.querySelector('[data-gbv4-alias]') || {}).textContent || '{}'); } catch (error) { alias = {}; }
    function tileFor(k) {
      if (k && alias[k]) k = alias[k];
      return /^[a-z0-9-]+$/.test(k || '') ? box.querySelector('[data-gbv3-fit="' + k + '"]') : null;
    }
    function handleOf(tile) { return tile ? tile.getAttribute('data-gbv3-fit') : ''; }
    var key = '';
    try { key = sessionStorage.getItem('gbv4Blaster') || ''; } catch (error) { key = ''; }
    var chosen = !!tileFor(key);
    key = handleOf(tileFor(key) || tileFor(box.getAttribute('data-default')) || box.querySelector('[data-gbv3-fit]'));

    function cartBlaster() {
      var cartUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
      return fetch(cartUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var hit = '';
        (cart.items || []).some(function (item) {
          hit = handleOf(tileFor(item.handle));
          return !!hit;
        });
        return hit;
      }).catch(function () { return ''; });
    }

    function load() {
      if (!loading) {
        var url = new URL(box.getAttribute('data-src'), location.href);
        url.searchParams.set('section_id', gridSectionId());
        loading = fetch(url.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }).then(function (html) {
          items = Array.prototype.slice.call(parse(html).querySelectorAll('#product-grid > li.grid__item'));
        }).catch(function (error) {
          loading = null;
          throw error;
        });
      }
      return loading;
    }

    function show() {
      var tile = tileFor(key);
      box.querySelectorAll('[data-gbv3-fit]').forEach(function (b) {
        var on = b === tile;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!tile || !items || renderedKey === key) return;
      var fits = sortItems(items.filter(function (li) {
        return (li.getAttribute('data-gbv3-fits') || '').indexOf(',' + key + ',') !== -1;
      }), 'data-gbv4-rank');
      var frag = doc.createDocumentFragment();
      fits.forEach(function (li) {
        var card = doc.importNode(li, true);
        card.hidden = false;
        fitBadge(card, tile);
        frag.appendChild(card);
      });
      list.textContent = '';
      list.appendChild(frag);
      renderedKey = key;
      list.classList.add('is-ready');
      if (allLink) allLink.hidden = true;
    }

    /* Cards 5+ remain in the normal grid flow, just like the first four. */
    /* Switching blasters keeps the shopper at the picker instead of scrolling a shorter list into view. */
    box.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-gbv3-fit]');
      if (!btn || !box.contains(btn)) return;
      key = btn.getAttribute('data-gbv3-fit');
      chosen = true;
      try { sessionStorage.setItem('gbv4Blaster', key); } catch (error) {}
      show();
      if (!items) load().then(show).catch(function () {});
    });

    function fill() {
      Promise.all([load(), chosen ? '' : cartBlaster()]).then(function (res) {
        if (!chosen && res[1] && res[1] !== key) {
          key = res[1];
          centerTile(box.querySelector('.gbv4-row'), tileFor(key));
        }
        show();
      }).catch(function () {});
    }

    show();
    centerTile(box.querySelector('.gbv4-row'), tileFor(key));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        fill();
      }, { rootMargin: '900px 0px' });
      io.observe(box);
    } else {
      fill();
    }
  }

  function start() {
    startFit();
    startFinder();
    startPickers();
    restore();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
